<template>
  <v-layout align-end justify-end>
    <v-text-field
      align-end
      flat
      :label="$t('searchPlaceholder')"
      v-model="searchValue"
    />
  </v-layout>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'SearchTextField',
  data () {
    return {
      searchValue: ''
    }
  },

  watch: {
    searchValue: _.debounce(async function (value) {
      this.$store.commit('setSearchValue', value)
    }, 500)

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SearchTextFiled.vue